module.exports = __webpack_public_path__ + "static/media/vue_ai.dba320ef.png";